import * as aiSearch from './slices/aiSearch/aiSearchSlice';
import * as config from './slices/config/configSlice';
import * as filters from './slices/filters/filtersSlice';
import { promotionsActions as promotions } from './slices/promotions/promotionsSlice';
import * as results from './slices/results/resultsSlice';
import { specialtiesActions as specialties } from './slices/specialties/specialtiesSlice';
import * as location from './slices/location/locationSlice';
import * as tooltip from './slices/tooltip/tooltipSlice';
import * as ui from './slices/ui/uiSlice';
import * as app from './appActions';
import * as map from './slices/map/mapSlice';
import * as notifications from './slices/notifications/notificationsSlice';
import * as chat from './slices/chat/chatSlice';
import * as search from './slices/search/searchSlice';
import * as banner from './slices/banner/bannerSlice';
import * as rewards from './slices/rewards/rewardsSlice';
import * as cost from './slices/cost/costSlice';
import * as referringClinic from './slices/referringClinic/referringClinicSlice';

const actions = {
  aiSearch,
  config,
  filters,
  promotions,
  results,
  specialties,
  tooltip,
  ui,
  app,
  map,
  notifications,
  chat,
  search,
  location,
  banner,
  rewards,
  cost,
  referringClinic,
};

export default actions;
